import { DEFAULT_THUMBNAIL_WIDTH, FileSource, Thumbnail } from '@nextforce/api'
import { makeStyles, useTheme } from '@rneui/themed'
import { useServer } from 'app/server/context'
import { Image } from 'expo-image'
import React, { useEffect, useState } from 'react'
import { ActivityIndicator } from 'react-native'
import { StatusBoundary } from 'shared/components/status_boundary'

interface ThumbnailImageProps {
  thumbnail: Thumbnail
}

export const THUMBNAIL_IMAGE_WIDTH = DEFAULT_THUMBNAIL_WIDTH
export const THUMBNAIL_IMAGE_MARGIN_HORIZONTAL = 5

export function ThumbnailImage({ thumbnail }: ThumbnailImageProps) {
  const styles = useStyles()
  const { theme } = useTheme()
  const { server } = useServer()
  const [source, setSource] = useState<FileSource | undefined>()
  const [error, setError] = useState<Error | undefined>()
  const [isLoading, setIsLoading] = useState(true)
  const { url, width, height } = thumbnail

  useEffect(() => {
    server.getFileSource(url).then(setSource).catch(setError)
  }, [server, url])

  return (
    <StatusBoundary isLoading={!source} error={error}>
      <Image
        style={[
          styles.messageImage,
          {
            aspectRatio: width / height,
          },
        ]}
        source={source}
        contentFit="cover"
        onLoadEnd={() => setIsLoading(false)}
      />
      {isLoading ? (
        <ActivityIndicator
          style={{
            position: 'absolute',
            flex: 1,
            alignSelf: 'center',
            top: '50%',
          }}
          color={theme.colors.primary}
        />
      ) : (
        <></>
      )}
    </StatusBoundary>
  )
}

const useStyles = makeStyles(theme => ({
  messageImage: {
    width: THUMBNAIL_IMAGE_WIDTH,
    marginTop: 7,
    marginBottom: 2,
    marginHorizontal: THUMBNAIL_IMAGE_MARGIN_HORIZONTAL,
    borderRadius: 8,
  },
}))
